module.exports = __webpack_public_path__ + "static/media/jasper-15.6fbe4d57.jpg";